import { render, staticRenderFns } from "./CityComboField.vue?vue&type=template&id=2250cd04&scoped=true"
import script from "./CityComboField.vue?vue&type=script&lang=js"
export * from "./CityComboField.vue?vue&type=script&lang=js"
import style0 from "./CityComboField.vue?vue&type=style&index=0&id=2250cd04&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2250cd04",
  null
  
)

export default component.exports